import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

import type { DataPointReport } from "../../types/reportTypes.ts"

export const getAllReports = async (): Promise<DataPointReport[]> => {
  const res = await authFetch(`${API_BASE}/reports`)
  const data: DataPointReport[] = await res.json()
  return data
}
